import { Component, Input, OnInit } from '@angular/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityNavigationHost, INavigationEntityRequest } from 'src/app/assets/shared/entity-navigation-host';
import { IProjectRelatedProject } from '../../interfaces/IProjectRelatedProject';
import { IProjectLink } from '../../interfaces/IProjectLink';

@Component({
  selector: 'eic-project-related-projects-and-links',
  templateUrl: './project-related-projects-and-links.component.html',
  styleUrl: './project-related-projects-and-links.component.scss'
})
export class ProjectRelatedProjectsAndLinksComponent implements OnInit {
  @Input() relatedProjects$: Observable<IProjectRelatedProject[]>;
  @Input() links$: Observable<IProjectLink[]>;

  vm$: Observable<{ relatedProjects: IProjectRelatedProject[]; links: IProjectLink[]; hasData: boolean; }>;

  constructor(private host: EntityNavigationHost) {
  }

  ngOnInit(): void {
    this.vm$ = combineLatest([
      this.relatedProjects$ ?? of([]),
      this.links$ ?? of([])
    ]).pipe(
      map(([relatedProjects, links]) => ({
        relatedProjects: relatedProjects ?? [],
        links: links ?? [],
        hasData: (relatedProjects?.length > 0) || (links?.length > 0)
      }))
    );
  }

  openRelatedProject(projectId: number, projectName: string): void {
    const request: INavigationEntityRequest = {
      entityType: 'project',
      id: projectId,
      name: projectName,
      caption: 'Project Details'
    };

    this.host.openEntity(request);
  }
}
